import Image from "next/image";
import {Fragment} from "react";

const SingleProject = props => {
    return (
        <>
            <Fragment>
                <div key={props.post.id} className="flex flex-col md:flex-row">
                    <div className="md:w-96 flex-col">
                        <div className="mt-auto">
                            <Image
                                alt="Logo of Dynamic Solution Innovators Ltd."
                                src={props.post.feature_image}
                                width="440"
                                height="272"
                                layout="responsive"
                                objectFit="cover"
                                loading="lazy"
                            />
                        </div>
                    </div>
                    <div className="flex flex-col md:w-1/2 pt-6 md:pt-0 md:pl-9 justify-end">
                        <div className="flex-auto font-body text-4xl font-extrabold">
                            {props.post.title}
                        </div>
                        <div className="bg-blue-500 h-1 w-20 my-6"></div>
                        <div className="font-body mb-12 font-light text-xl text-gray-600 italic">
                            {props.post.excerpt}
                        </div>
                    </div>
                </div>
                <div className="">
                    {/* <div className="font-body text-2xl font-extrabold pb-4">
            {props.post.meta_title}
          </div> */}
                    <div
                        className="ghostContent font-body border-none text-left text-xl text-gray-600"
                        dangerouslySetInnerHTML={{
                            __html: props.post.html,
                        }}
                    ></div>
                </div>
            </Fragment>
        </>
    );
};

export default SingleProject;
